<script setup>
import { reactiveOmit } from "@vueuse/core";
import { TooltipArrow, useForwardProps } from "reka-ui";
import { cn } from "@/lib/utils";

const props = defineProps({
  width: { type: Number, required: false, default: 10 },
  height: { type: Number, required: false, default: 5 },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
});

const delegatedProps = reactiveOmit(props, "class");
const forwarded = useForwardProps(delegatedProps);
</script>

<template>
  <TooltipArrow
    data-slot="tooltip-arrow"
    v-bind="forwarded"
    :class="cn('fill-current', props.class)"
  />
</template>
